import { Component, OnInit , Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { LoanService } from "../../../../loan/shared/loan.service";
import { PrintloanemiService } from "../../../shared/print/printloanemi.service";

@Component({
  selector: 'app-rptloanemipopup',
  templateUrl: './rptloanemipopup.component.html',
  styleUrls: ['./rptloanemipopup.component.css']
})
export class RptloanemipopupComponent implements OnInit {

  CustomerList: any[] =[];

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loanService: LoanService,
    private printloanemiService: PrintloanemiService,
    ) { }

  ngOnInit() {
    
    this.GetCustomer();
    this.data.customerId = 0 ;
  }

  GenerateReports(): void {
    
    this.data.customerId = this.data.customerId;
    this.data.ReportName = "CustomerEMI";
    this.printloanemiService.GenerateReport(this.data);
    this.dialogRef.close();
  }

  GetCustomer() {
    this.loanService.FetchCustomerList().subscribe(data => {
      this.CustomerList = data;
    })
  }

}
